 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ACOVER from '@/components/1-cover'
 import BIRDSFRONT from '@/components/birdsfront'
 import LOVE_1 from '@/components/love_1'
 import ATITLE_PAGE from '@/components/2-title_page'
 import ATOC from '@/components/3-TOC'
 import V11COVER from '@/components/v1/1-cover'
 import V12TITLE_PAGE from '@/components/v1/2-title_page'
 import V13DEDICATION from '@/components/v1/3-dedication'
 import V14TOC from '@/components/v1/4-TOC'
 import V15CHAP1 from '@/components/v1/5-chap1'
 import V16CHAP2 from '@/components/v1/6-chap2'
 import V17CHAP2 from '@/components/v1/7-chap2'
 import V18CHAP3 from '@/components/v1/8-chap3'
 import V19CHAP3 from '@/components/v1/9-chap3'
 import V110CHAP4 from '@/components/v1/10-chap4'
 import V111CHAP5 from '@/components/v1/11-chap5'
 import V112CHAP6 from '@/components/v1/12-chap6'
 import V113CHAP6 from '@/components/v1/13-chap6'
 import V114CHAP7 from '@/components/v1/14-chap7'
 import V115CHAP7 from '@/components/v1/15-chap7'
 import V116CHAP8 from '@/components/v1/16-chap8'
 import V117CHAP8 from '@/components/v1/17-chap8'
 import V118CHAP9 from '@/components/v1/18-chap9'
 import V119CHAP10 from '@/components/v1/19-chap10'
 import V2COVERIMAGE from '@/components/v2/CoverImage'
 import V22TITLE_PAGE from '@/components/v2/2-title_page'
 import V2HOWIGREW from '@/components/v2/HowIGrew'
 import V2HOWIGREW1 from '@/components/v2/HowIGrew-1'
 import V2HOWIGREW3 from '@/components/v2/HowIGrew-3'
 import V2HOWIGREW4 from '@/components/v2/HowIGrew-4'
 import V2HOWIGREW5 from '@/components/v2/HowIGrew-5'
 import V2HOWIGREW6 from '@/components/v2/HowIGrew-6'
 import V2HOWIGREW7 from '@/components/v2/HowIGrew-7'
 import V2HOWIGREW8 from '@/components/v2/HowIGrew-8'
 import V2HOWIGREW9 from '@/components/v2/HowIGrew-9'
 import V2HOWIGREW10 from '@/components/v2/HowIGrew-10'
 import V2HOWIGREW11 from '@/components/v2/HowIGrew-11'
 import V2HOWIGREW12 from '@/components/v2/HowIGrew-12'
 import V2HOWIGREW13 from '@/components/v2/HowIGrew-13'
 import V31COVER from '@/components/v3/1-cover'
 import V32TITLE_PAGE from '@/components/v3/2-title_page'
 import V33TOC from '@/components/v3/3-TOC'
 import V34CHAP1 from '@/components/v3/4-chap1'
 import V35CHAP2 from '@/components/v3/5-chap2'
 import V36CHAP3 from '@/components/v3/6-chap3'
 import V37CHAP4 from '@/components/v3/7-chap4'
 import LOVE_2 from '@/components/love_2'
 import V314BIOGRAPHY from '@/components/v3/14-biography'
 import V315CHAP5 from '@/components/v3/15-chap5'
 import V316CHAP6 from '@/components/v3/16-chap6'
 import V38BIOGRAPHY from '@/components/v3/8-biography'
 import V39BIOGRAPHY from '@/components/v3/9-biography'
 import V310BIOGRAPHY from '@/components/v3/10-biography'
 import V311BIOGRAPHY from '@/components/v3/11-biography'
 import V312BIOGRAPHY from '@/components/v3/12-biography'
 import V313BIOGRAPHY from '@/components/v3/13-biography'
 import V317COPYRIGHT from '@/components/v3/17-copyright'
 import BACKAD from '@/components/backad'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/3-TOC",
 			"name" : "3-TOC",
 			"component" : ATOC
 		},
 		{
 			"path" : "/v1/1-cover",
 			"name" : "v1/1-cover",
 			"component" : V11COVER
 		},
 		{
 			"path" : "/v1/2-title_page",
 			"name" : "v1/2-title_page",
 			"component" : V12TITLE_PAGE
 		},
 		{
 			"path" : "/v1/3-dedication",
 			"name" : "v1/3-dedication",
 			"component" : V13DEDICATION
 		},
 		{
 			"path" : "/v1/4-TOC",
 			"name" : "v1/4-TOC",
 			"component" : V14TOC
 		},
 		{
 			"path" : "/v1/5-chap1",
 			"name" : "v1/5-chap1",
 			"component" : V15CHAP1
 		},
 		{
 			"path" : "/v1/6-chap2",
 			"name" : "v1/6-chap2",
 			"component" : V16CHAP2
 		},
 		{
 			"path" : "/v1/7-chap2",
 			"name" : "v1/7-chap2",
 			"component" : V17CHAP2
 		},
 		{
 			"path" : "/v1/8-chap3",
 			"name" : "v1/8-chap3",
 			"component" : V18CHAP3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js